import { create } from "zustand";

const useChatStore = create((set) => ({
  isUserSignedIn: false, // Default login status
  currentScreen: "home", // Default screen ('chat', 'orderList', 'login')

  // Actions to update state
  signIn: () => set({ isUserSignedIn: true }),
  signOut: () => set({ isUserSignedIn: false }),
  setCurrentScreen: (screen) => set({ currentScreen: screen }),
  orderDetails: null,
  setOrderDetails: (order) => set({ orderDetails: order }),
  faqInfo: null,
  setFaqInfo: (info) => set({ faqInfo: info }),
  isFetched: false,
  setIsFetched: (fetched) => set({ isFetched: fetched }),
  createdOrderInfo: null,
  setCreatedOrderInfo: (info) => set({ createdOrderInfo: info }),
  ticketRaisedInfo: [],
  setTicketRaisedInfo: (info) => set({ ticketRaisedInfo: info }),
  inputValue: "",
  setInputValue: (val) => set({ inputValue: val }),
  chatbotTheme: "#006BEA",
  setChatbotTheme: (val) => set({ chatbotTheme: val }),
}));

export default useChatStore;
